import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash'
import '../styles/accordion_style.css'
import moment from 'moment';
import {  addShipyardToWatchlist, removeShipyardFromWatchlist } from '../../redux/action/fleet.action';
import { getRouteToCompany } from '../../redux/action/vessels.action';

export const PreviewProperty = (filter) => {
  const dispatch = useDispatch();
  const currentFeature = useSelector(state => state.mapData.currentFeature);
  const masterData = useSelector(state => state.mapData.currentPropertyMasterData);
  const vesselVisitsData = useSelector(state => state.mapData.currentPropertyVesselVisitsData);
  const shipyardVisitsData = useSelector(state => state.mapData.currentPropertyShipyardVisitsData);
  const vesselRoute = useSelector(state => state.mapData.vesselRoute);
  const vesselTracking = useSelector(state => state.mapData.vesselTracking);
  let docks = useSelector(state => state.mapData.docks);
  let [currentVesselRoute, setCurrentVesselRoute] = useState(vesselRoute);
  let [currentVesselTracking, setCurrentVesseTracking] = useState(vesselTracking);
  let vesselInAnchorage = useSelector(state=>state.mapData.vesselsInAnchorage);
  let company = useSelector(state => state.user.company)
  let currentTab = useSelector(state => state.ui.currentTab);

  const addDefaultImageSrc = (ev) => {
    ev.target.src = '/img/1x1.png'
  }

  return (
    <>
      { !_.isEmpty(currentFeature) && currentFeature.properties.type === 'vessel' &&
        <>
          { !isNaN(currentFeature.properties.imo) &&
          <h4 className="gradient-title mb10" ><a style={{textDecoration: 'none', color: 'white'}} href={"/vessel/" + currentFeature.properties.imo+ "-" + _.kebabCase(currentFeature.properties.name)} target="_blank">{currentFeature.properties.name}</a></h4>
          }

          { currentFeature.properties.fleet_name &&
            <div className="row mt10 mb10">
              <div className="col-xs-12">
                <button style={{width:'100%'}}
                  onClick={()=>{
                    dispatch(removeVesselFromFleet({myVesselId: currentFeature.properties.my_vessel_id, fleetId: currentFeature.properties.fleet_id}))
                  }}
                >Remove from watchlist</button>
              </div>
            </div>
          } 
          {currentTab ==='ETA' && !currentFeature.properties.fleet_name &&
            <div className="row mt10 mb10">
              { currentVesselRoute.features.length == 0 &&
                <div className="col-xs-6">
                  <button style={{width: '100%'}}
                          onClick={() => {
                            dispatch(getRouteToCompany({imo: currentFeature.properties.imo, companyId:company.id}))
                            setCurrentVesselRoute(vesselRoute)
                          }}
                  >Show route to shipyard
                  </button>

                </div>
              }
              { currentVesselRoute.features.length > 0 &&
                <div className="col-xs-6">
                  <button style={{width: '100%'}}
                          onClick={() => {
                            dispatch(removeRoute({imo: currentFeature.properties.imo}))
                            setCurrentVesselRoute(vesselRoute)
                          }}
                  >Hide route to shipyard
                  </button>

                </div>
              }
            </div>
          }
          <table className="table table-default nowrap">
            <tbody>
               {
                 currentFeature.properties.manager_in_text && currentFeature.properties.manager_in_text !== 'null' &&
                 <tr><td>Shipmanager</td><td><a href={"/ship-manager/" + currentFeature.properties.manager_id+ "-" + _.kebabCase(currentFeature.properties.manager_in_text)}  target="_blank">{_.startCase(_.toLower(currentFeature.properties.manager_in_text))}</a></td></tr>
              }
              { currentFeature.properties.fleet_name &&
                <tr><td>Fleet</td><td>{currentFeature.properties.fleet_name}</td></tr>
              }
              {
                currentFeature.properties.engine_name &&
                <tr><td>Product installed</td><td>${currentFeature.properties.engine_name}</td></tr>
              }
              { !isNaN(currentFeature.properties.imo) &&
                <tr><td>Name</td><td><a href={"/vessel/" + currentFeature.properties.imo+ "-" + _.kebabCase(currentFeature.properties.name)} target="_blank">{currentFeature.properties.name}</a></td></tr>
              }
              { isNaN(currentFeature.properties.imo) &&
                <tr><td>Name</td><td>{currentFeature.properties.name}</td></tr>
              }
              {currentFeature.properties.imo != "null" &&
              <tr>
                <td>IMO</td>
                <td>{currentFeature.properties.imo}</td>
              </tr>
              }

              <tr><td>Length x Width</td><td>{currentFeature.properties.length}m x {currentFeature.properties.width}m</td></tr>
               {currentFeature.properties.draught != "null" &&
                <tr><td>Current Draught</td><td>{currentFeature.properties.draught}m</td></tr>
               }
               <tr><td>Type</td><td>{_.startCase(_.toLower(currentFeature.properties.vessel_type))}</td></tr>
              {currentFeature.properties.scrubber_installed != "null" &&
                <tr><td>Scrubber</td><td>{currentFeature.properties.scrubber_installed?"Installed":"NOT Installed"}</td></tr>
              }

              { currentFeature.properties.eta && currentFeature.properties.eta !== 'null' && currentFeature.properties.destination && currentFeature.properties.destination !== 'null' &&
                <>
                <tr><td>ETA</td><td>{currentFeature.properties.eta}</td></tr>
                <tr><td>Destination</td><td>{currentFeature.properties.destination.replace(/[@"]/g,"")}</td></tr>
                </>
              }
              <tr><td>Updated At</td><td>{currentFeature.properties.positiontimestamp}</td></tr>
              { currentFeature.properties.next_survey && currentFeature.properties.next_survey !== 'null' &&
                <tr><td>Class Expires</td><td>{currentFeature.properties.next_survey}</td></tr>
              }
            </tbody>
          </table>
        </>
      }

      { !_.isEmpty(currentFeature) && currentFeature.properties.type === 'shipyard' &&
        <>
          <h4 className="gradient-title mb10"><a href={"/shipyards/" + currentFeature.properties.id + "-" + _.kebabCase(currentFeature.properties.name)} target="_blank">{currentFeature.properties.name}</a></h4>
          <div className="row mt10 mb10">
            <div className="col-xs-12">
              {currentFeature.properties.watchlist &&
                <button
                  onClick={()=>{
                    dispatch(removeShipyardFromWatchlist({shipyardId: currentFeature.properties.id}))
                  }}
                >Remove from watchlist</button>
              }
              {!currentFeature.properties.watchlist &&
                <button
                  onClick={()=>{
                    dispatch(addShipyardToWatchlist({shipyardId: currentFeature.properties.id}))
                  }}
                >Add to watchlist</button>
              }
            </div>
          </div>
          { vesselRoute && vesselRoute.features &&  vesselRoute.features[0] &&
            <table className="table table-default">
              <tbody>
                <tr><td>ETA</td><td>{vesselRoute.features[0].properties.eta}</td></tr>
                <tr><td>Distance</td><td>{vesselRoute.features[0].properties.distance}</td></tr>
                <tr><td>Speed</td><td>15Kn</td></tr>
                <tr><td>Deviation cost</td><td>{(Math.round((vesselRoute.features[0].properties.journeyTime/1000/60/60/24) * (8000 + 30 * 350))).toString()}$</td></tr>
              </tbody>
            </table>
          }
          { docks &&
            <table className="table table-default mt10">
              <thead><tr><th>Type</th><th>Length(m)</th><th>Width(m)</th></tr></thead>
              <tbody>
                { 
                  docks.map(d => {
                    return (
                      <tr key={"dock_" + d.id}><td>{d.type}</td><td>{d.length}</td><td>{d.width}</td></tr>
                    )
                  })
                }
              </tbody>
            </table>
          }
        </>
      }
      { !_.isEmpty(currentFeature) && currentFeature.properties.type === 'port' &&
      <>
        <h4 className="gradient-title mb10"><a href={"/ports/" + currentFeature.properties.id + "-" + _.kebabCase(currentFeature.properties.name)} target="_blank">{currentFeature.properties.name}</a></h4>
      </>
      }

      { !_.isEmpty(currentFeature) && vesselVisitsData && !_.isEmpty(vesselVisitsData) && vesselVisitsData.length > 0 && currentFeature.properties.type === 'vessel' &&
        <>
          <table className="table table-default mt10">
            <thead>
              <tr><th>Visited Shipyards</th><th className="nowrap">from<br />to</th><th>Duration<br />(days)</th></tr>
            </thead>
            <tbody>
              {
                vesselVisitsData.filter(vv => vv.source == "vesselVisits").map(v => {
                  return(
                    <tr key={"visits_"+ v.imo + "_" + v.startTS+ "_" + v.company.id }>
                      <td>
                        {v.company.url &&
                          <a href={v.company.url} target="_blank">
                            {v.company.name}
                          </a>
                        }
                        {!v.company.url &&
                        <p>
                          {v.company.name}
                        </p>
                        }
                      </td>
                      <td className="nowrap">
                      {moment(v.startTS).format('YYYY-MM-DD')}<br />
                      {v.endTS ? moment(v.endTS).format('YYYY-MM-DD'): "-"}
                      </td>
                      <td>{v.duration}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </>
      }

      { !_.isEmpty(currentFeature) && !_.isEmpty(shipyardVisitsData) && currentFeature.properties.type === 'shipyard' &&
        <>
          <table className="table table-default">
            <thead>
              <tr><th>Current vessels</th><th className="nowrap">from<br />to</th><th>Duration<br />(days)</th></tr>
            </thead>
            <tbody>
              {
                shipyardVisitsData.map(v => {
                  return(
                    <tr key={"visits_"+ v.imo + "_" + v.startTS+ "_" + v.company.id}>
                      <td>
                        <a href={v.vessel.vesselUrl} target="_blank">
                          {v.vessel.name} <br />
                          IMO: {v.vessel.imo} 
                        </a>
                      </td>
                      <td className="nowrap">
                      {moment(v.startTS).format('YYYY-MM-DD')}<br />
                      {v.endTS ? moment(v.endTS).format('YYYY-MM-DD'): "-"}
                      </td>
                      <td>{v.duration}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </>
      }

      { !_.isEmpty(currentFeature) && !_.isEmpty(masterData) && currentFeature.properties.type === 'vessel' &&
        <div className="panel-group mt10" id="accordion" role="tablist" aria-multiselectable="true">
          {
            ["generalDetails", "managementDetails", "tonnageDetails", "dimensionDetails", "capacityDetails", "yardDetails", "classificationDetails", "engineDetails"].map((detailKey)=> {
              if (!_.isEmpty(masterData[detailKey])){
                return (
                  <div className="panel panel-default" key={"accordion_" + detailKey}>
                    <div className="panel-heading" role="tab" id={"heading_" + detailKey}>
                      <a role="button" data-toggle="collapse" data-parent="#accordion" href={"#collapse_" + detailKey} aria-expanded="true" aria-controls={"collapse_" + detailKey}>
                        <h4 className="panel-title ">{_.startCase(detailKey)}
                          <span className="fa fa-caret-up" style={{float:"right"}}></span>
                        </h4>
                      </a>
                    </div>
                    <div id={"collapse_" + detailKey} className="panel-collapse collapse" role="tabpanel" aria-labelledby={"heading_" + detailKey}>
                      <div className="panel-body">
                        <table className="table table-default">
                          <tbody>
                            { Object.keys(masterData[detailKey]).map((key) => { 
                              return(
                                <tr key={detailKey +"_" + key}><td>{key}</td><td>{masterData[detailKey][key]}</td></tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )
              } else {
                return;
              }
            })
          }
        </div>
      }

      {!_.isEmpty(currentFeature) && currentFeature.properties.type === 'underwater' &&
        <>
          <h4 className="gradient-title mb10">Underwater Service</h4>
          <table className="table table-default">
            <tbody>
              {!isNaN(currentFeature.properties.id) &&
                <tr><td>Name</td><td><a href={"/shipyards/" + currentFeature.properties.id + "-" + _.kebabCase(currentFeature.properties.name)} target="_blank">{currentFeature.properties.name}</a></td></tr>
              }
              {isNaN(currentFeature.properties.id) &&
                <tr><td>Name</td><td>{currentFeature.properties.name}</td></tr>
              }
              {masterData?.portContact?.email &&
                <tr><td>Email</td><td>{masterData.portContact.email}</td></tr>
              }
              {masterData?.portContact?.phone &&
                <tr><td>Phone</td><td>{masterData.portContact.phone}</td></tr>
              }
              {masterData?.portContact?.mobile &&
                <tr><td>Mobile</td><td>{masterData.portContact.mobile}</td></tr>
              }
              {masterData?.portServices &&
                <tr>
                  <td>Available Services</td>
                  <td>
                    {masterData.portServices.map(s => {
                      return (
                        <Fragment key={"servi_" + s.id}> {s.name} <br /></Fragment>
                      )
                    })
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </>
      }

      { !_.isEmpty(currentFeature) && masterData.picture && currentFeature.properties.type === 'vessel' &&
      <img onError={addDefaultImageSrc} src={masterData.picture} />
      }
    </>
  );
}

export default PreviewProperty;